<ub-card [variant]="'success'" [rounded]="true" [dividers]="false">
  <h3 title>{{ bookingType.doc.name }}</h3>
  <div content>
    @if (bookingType.doc.translationInfo) {
      <eas-translation-info-list [translationInfo]="bookingType.doc.translationInfo">
      </eas-translation-info-list>
    }
  </div>
  <div actions>
    @if (buttons) {
      <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
    }
  </div>
</ub-card>
